import layouts from './layouts.json';

export enum ColumnSize {
    ONE = 1,
    TWO = 2,
    THREE = 3,
    FOUR = 4,
    FIVE = 5,
}

export interface GridBlock {
    id?: string;
    x: number;
    y: number;
    w: number;
    h: number;
}

export interface Grid {
    [ColumnSize.ONE]: GridBlock[];
    [ColumnSize.TWO]: GridBlock[];
    [ColumnSize.THREE]: GridBlock[];
    [ColumnSize.FOUR]: GridBlock[];
    [ColumnSize.FIVE]?: GridBlock[];
}

export const OpenGrid: Grid = layouts.open;
export const OpenSimpleGrid: Grid = layouts.openSimple;
